import * as Sentry from '@sentry/react';
import { NbFallback } from 'noddi-ui-web';
import { PropsWithChildren } from 'react';

export function NoddiErrorBoundary({ children }: PropsWithChildren) {
  return <Sentry.ErrorBoundary fallback={<NbFallback />}>{children}</Sentry.ErrorBoundary>;
}
